import { useState, useMemo, useContext, createContext, } from "react"
import { NOOP, } from "@fedsim/helpers"

const SelectedItemContext = createContext({ id: false, setId: NOOP, groupName: "", setGroupName : NOOP,})

export const SelectedItemProvider = ({ children, }) => {
  const [id, setId,] = useState(false)
  const value = useMemo(() => ({ id, setId }), [ id,])

  return <SelectedItemContext.Provider value={value}>{children}</SelectedItemContext.Provider>
}

export function useSelectedItemContext() {
  const context = useContext(SelectedItemContext)
  if (!context) {
    throw new Error("SelectedItem compound components cannot be rendered outside the SelectedItem component")
  }
  return context
}

export const SelectedItemConsumer = SelectedItemContext.Consumer

export default SelectedItemContext
